<template>
  <div id="page-eshops-list">

    <!-- BREADCRUMB SECTION -->
    <vs-row class="mb-5" vs-align="center">
      <vs-col vs-w="12">
        <h2 class="breadcrumb">Changed Prices</h2>
      </vs-col>
    </vs-row>
    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">

        </div>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue ref="agGridTable" :gridOptions="gridOptions"
                   class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                   :defaultColDef="defaultColDef"
                   :rowData="recordsData" rowSelection="multiple" colResizeDefault="shift"
                   :animateRows="true"
                   :floatingFilter="true" :pagination="true" :cacheBlockSize="10"
                   :paginationPageSize="paginationPageSize"
                   :paginationAutoPageSize="true" :filter="true">
      </ag-grid-vue>

    </div>
  </div>
</template>

<script>
import CellRendererStatus from "@/views/cell-renderer-eshops/CellRendererStatus";
import CellRendererActions from "@/views/cell-renderer-eshops/CellRendererActions";
import {AgGridVue} from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  name: "PricesChangedList",
  components: {
    AgGridVue,
    vSelect,
    flatPickr,
    CellRendererStatus,
    CellRendererActions
  },
  data() {
    return {
      // AgGrid
      gridApi: null,
      gridOptions: {
        floatingFilter: true,
        filter: true,
        pagination: true,
        pivotPanelShow: 'always',
        colResizeDefault: 'shift',
        animateRows: true,
        resizable: true,
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: 'date_changed',
          field: 'date_changed',
          width: 125,
          filter: 'agTextColumnFilter',
          flex: 1,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: 'product',
          field: 'product.name',
          filter: 'agTextColumnFilter',
          flex: 1,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: 'part number',
          field: 'product.part_number',
          filter: 'agTextColumnFilter',
          flex: 1,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: 'price From',
          field: 'priceFrom',
          filter: 'agTextColumnFilter',
          flex: 1,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: 'price To',
          field: 'priceTo',
          filter: 'agTextColumnFilter',
          flex: 1,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: 'eshop partner',
          field: 'eshop_partner',
          filter: 'agTextColumnFilter',
          flex: 1,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
      ],
    }
  },
  computed: {
    recordsData() {
      return this.$store.getters.getChangedPrices
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      },
    }
  },
  methods: {

  },
  mounted() {
    this.gridApi = this.gridOptions.api
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if (this.userInfo.uid === 1) {
      this.$vs.loading()
      this.$store.dispatch('fetchChangedPrices').then(() => {
        this.$vs.loading.close()
      })
      this.$vs.loading.close()
    }

  },
}
</script>

<style scoped>

</style>
